import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AnalyticsModule, CdTableModule } from '@lbmx/analytics';
import { LuiWidgetWrapperModule, LuiWizardModule, LuiWizardV3Module, PerFormPrimengModule } from '@lbmx/per-form-primeng';
import { SearchContainerLoaderComponent, SearchContainerLoaderModule } from '@lbmx/search-container';
import { TranslocoModule } from '@ngneat/transloco';
import { FlexmonsterPivotModule } from 'ng-flexmonster';
import { DynamicDialogModule, ProgressSpinnerModule } from 'primeng-lts';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
// import { InputTextModule } from 'primeng-lts';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { AddOptionModule } from './admin-centre/data-preferences/options/add-option/add-option.module';
import { EditOptionModule } from './admin-centre/data-preferences/options/edit-option/edit-option.module';
import { PurchasesDataPreferenceComponent } from './admin-centre/data-preferences/purchases-data-preference/purchases-data-preference.component';
import { SalesDataPreferenceComponent } from './admin-centre/data-preferences/sales-data-preference/sales-data-preference.component';
import { DashboardLoaderComponent } from './dashboard-loader/dashboard-loader.component';
import { DashboardTemplateComponent } from './dashboard-template/dashboard-template.component';
import { AddEditExclusionModule } from './exclusions/add-edit-exclusion/add-edit-exclusion.module';
import { BdmAdministrationComponent } from './exclusions/bdm-administration/bdm-administration.component';
import { ExcludeOptionsModule } from './exclusions/exclude-options/exclude-options.module';
import { OrderedByLocationExclusionComponent } from './exclusions/ordered-by-location-exclusion/ordered-by-location-exclusion.component';
import { ProductExclusionComponent } from './exclusions/product-exclusion/product-exclusion.component';
import { SupplierLocationExclusionComponent } from './exclusions/supplier-location-exclusion/supplier-location-exclusion.component';
import { FlexmonsterLoaderComponent } from './flexmonster-loader/flexmonster-loader.component';
import { FlexmonsterComponent } from './flexmonster/flexmonster.component';
import { AssignOptionsModule } from './member-account-rep/assign-member-rep-options/assign-options.module';
import { MemberAccountRepComponent } from './member-account-rep/member-account-rep.component';
import { ReassignOptionsModule } from './member-account-rep/reassign-member-rep-options/reassign-options.module';
import { PurchasesBySupplierReportComponent } from './purchases-by-supplier-report/purchases-by-supplier-report.component';
import { ReportBuilderLandingComponent } from './report-builder-landing/report-builder-landing.component';
import { ReportLoaderComponent } from './report-loader/report-loader.component';
import { ReportsComponent } from './reports/reports.component';
import { WidgetSelectionComponent } from './widget-selection/widget-selection.component';

@NgModule({
  declarations: [
    DashboardLoaderComponent,
    DashboardTemplateComponent,
    PurchasesBySupplierReportComponent,
    ReportLoaderComponent,
    ReportsComponent,
    WidgetSelectionComponent,
    FlexmonsterComponent,
    FlexmonsterLoaderComponent,
    ReportBuilderLandingComponent,
    OrderedByLocationExclusionComponent,
    SupplierLocationExclusionComponent,
    BdmAdministrationComponent,
    ProductExclusionComponent,
    MemberAccountRepComponent,
    PurchasesDataPreferenceComponent,
    SalesDataPreferenceComponent,
  ],
  imports: [
    AnalyticsModule,
    CdTableModule,
    CommonModule,
    DynamicDialogModule,
    PerFormPrimengModule,
    ProgressSpinnerModule,
    TranslocoModule,
    FlexmonsterPivotModule,
    DropdownModule,
    FormsModule,
    InputTextModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    SearchContainerLoaderModule,
    ExcludeOptionsModule,
    CalendarModule,
    AssignOptionsModule,
    ReassignOptionsModule,
    AddEditExclusionModule,
    AddOptionModule,
    EditOptionModule
  ],
  exports: [DashboardLoaderComponent],
  entryComponents: [WidgetSelectionComponent],
})
export class MarketplaceAnalyticsModule {}
